var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4737 1.64207C13.0088 1.64207 12.6316 2.02018 12.6316 2.48418C12.6316 2.94818 13.0088 3.32628 13.4737 3.32628C13.9385 3.32628 14.3158 2.94818 14.3158 2.48418C14.3158 2.02018 13.9385 1.64207 13.4737 1.64207ZM13.4737 -3.24249e-05C14.8665 -3.24249e-05 16 1.1051 16 2.46313C16 3.53214 15.2943 4.43447 14.3158 4.77439V15.5789C14.3158 16.044 13.9388 16.421 13.4737 16.421C13.0086 16.421 12.6316 16.044 12.6316 15.5789V4.77439C11.6531 4.43447 10.9474 3.53214 10.9474 2.46313C10.9474 1.1051 12.0808 -3.24249e-05 13.4737 -3.24249e-05Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00005 7.15789C8.46489 7.15789 8.84216 7.536 8.84216 8C8.84216 8.464 8.46489 8.8421 8.00005 8.8421C7.53521 8.8421 7.15795 8.464 7.15795 8C7.15795 7.536 7.53521 7.15789 8.00005 7.15789ZM8.00005 0C7.53497 0 7.15795 0.377023 7.15795 0.842105V5.62558C6.17942 5.96549 5.47374 6.86783 5.47374 7.93684C5.47374 9.00585 6.17942 9.90819 7.15795 10.2481L7.15795 15.5789C7.15795 16.044 7.53497 16.4211 8.00005 16.4211C8.46513 16.4211 8.84216 16.044 8.84216 15.5789V10.2481C9.82068 9.90819 10.5264 9.00585 10.5264 7.93684C10.5264 6.86783 9.82068 5.96549 8.84216 5.62558V0.842105C8.84216 0.377023 8.46513 0 8.00005 0Z",
    fill: "#3C7AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52642 13.0526C2.99126 13.0526 3.36852 13.4307 3.36852 13.8947C3.36852 14.3587 2.99126 14.7368 2.52642 14.7368C2.06158 14.7368 1.68431 14.3587 1.68431 13.8947C1.68431 13.4307 2.06158 13.0526 2.52642 13.0526ZM3.36852 11.6466L3.36852 0.842105C3.36852 0.377023 2.9915 0 2.52642 0C2.06134 0 1.68431 0.377023 1.68431 0.842105L1.68431 11.6466C0.705786 11.9865 0.000102043 12.8889 0.000102043 13.9579C0.000102043 15.3159 1.13358 16.4211 2.52642 16.4211C3.91926 16.4211 5.05273 15.3159 5.05273 13.9579C5.05273 12.8889 4.34705 11.9865 3.36852 11.6466Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.c5d226cb495e143bcd6e8b3cafd92b2f.svg";
export { ForwardRef as ReactComponent };